import notify from '../../api/notification'
import supplyService from '../../api/supply'
import Moment from 'moment'

import {
  SUPPLY_LOADING,
  SUPPLY_UPDATE_LIST
} from '../types'

const state = {
  list: [],
  loading: false
}

const mutations = {
  [SUPPLY_LOADING] (state, data) {
    state.loading = data
  },
  [SUPPLY_UPDATE_LIST] (state, data) {
    state.list = data
  }
}

const getters = {
  supplyList: state => {
    return state.list
  },
  supplyLoading: state => {
    return state.loading
  }
}

const actions = {
  supplyUpdateList: ({ commit }, query) => {
    commit(SUPPLY_LOADING, true)
    return supplyService
      .getSupplyRequests(query)
      .then((res) => {
        if (res.status === 200) {
          let items = res.data
          items.map((item) => {
            item.number = item.number.toString()
            item.createdAt = Moment(item.createdAt).format('DD/MM/YYYY')
            return item
          })
          commit(SUPPLY_UPDATE_LIST, items)
          commit(SUPPLY_LOADING, false)
        }
      })
      .catch(() => {
        commit(SUPPLY_LOADING, false)
        notify({
          title: 'AVISO: ',
          message: 'Erro ao carregar requisições.'
        })
      })
  }
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
